module.exports = __webpack_public_path__ + "img/Z61_16.0957b3ec.jpg";